import Rest from '@/services/Rest';

/**
 * @typedef {CouponService}
 */
export default class CouponService extends Rest {
  /**
   * @type {String}
   */
  static resource = '/coupon'
}